export type ApiError = ServerErrorEnum // Override<Error, typeof ServerErrorEnum>

export enum ServerErrorEnum {
  UserNotAuthorized = 'e_account_unauthorized',
  EmptyAccountToken = 'e_account_token_empty',
}
